<script>
    import { notifications } from "./../stores/notifications.js";
    import { slide } from "svelte/transition";
</script>

<style>
    .overlay {
        position: fixed;
        z-index: 999;
        display: flex;
        flex-direction: column-reverse;
        width: 100vw;
        top: 0;
        left: 0;
        right: 0;
    }

    .overlay > div {
        background-color: #333333;
        color: white;
        padding: 1em;
        display: flex;
        justify-content: center;
        align-items: baseline;
        box-sizing: border-box;
        border-bottom: 1px solid #33333322;
    }

    .overlay > div:first-child {
        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
            0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
    }

    .title {
        font-size: 1.2em;
        margin-right: 0.5em;
    }

    .body {
        font-weight: 200;
    }

    div.error {
        background-color: #cc6666;
    }

    div.error {
        background-color: #cc6666;
    }

    div.success {
        background-color: #b5ead7;
        color: #333333;
    }

    div.info {
        background-color: #6eb5ff;
    }

    div.warn {
        background-color: #f3dd83;
        color: #333333;
    }
</style>

<div class="overlay">
    {#each $notifications as notification}
        <div
            class={notification.type}
            transition:slide={{ key: notification.uid }}>
            <span class="title">{notification.title || ''}</span>
            <span class="body">{notification.body || ''}</span>
        </div>
    {/each}
</div>
